import * as types from '../../../constants/actionTypes';
import api from '../../../../shared/api.json';

export function fetchUserCompanies() {
    return {
        types: [
            types.FETCH_USER_COMPANIES,
            types.FETCH_USER_COMPANIES_SUCCESS,
            types.FETCH_USER_COMPANIES_FAIL,
        ],
        promise: (client) => client.get(api.userCompany.index),
    };
}

/**
 * Creates an employer profile
 * @param {string} id company id
 */
export function createProfile(id) {
    return {
        types: [
            types.CREATE_PROFILE,
            types.CREATE_PROFILE_SUCCESS,
            types.CREATE_PROFILE_FAIL,
        ],
        promise: (client) =>
            client.post(api.userCompany.create, { data: { id } }),
    };
}

export function companySelected(selectedCompany) {
    return {
        type: types.COMPANY_SELECTED,
        selectedCompany,
    };
}
